export default "__VITE_ASSET__73e5de50__"